import { IconProps } from "../../utils/global-types/global-types";

const OutcomeIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M15.4133 7.25505C15.5089 7.799 15.0523 8.25 14.5 8.25H10.25C9.97385 8.25 9.75 8.02615 9.75 7.75V3.50001C9.75 2.94773 10.201 2.49119 10.745 2.58675C11.1574 2.65922 11.5617 2.77669 11.9505 2.93771C12.6481 3.22667 13.282 3.65021 13.8159 4.18415C14.3498 4.71809 14.7734 5.35196 15.0623 6.0496C15.2233 6.4383 15.3408 6.8426 15.4133 7.25505ZM14.4169 10.4954C14.5085 9.9508 14.0523 9.5 13.5 9.5H8.98C8.7118 9.5 8.49135 9.2884 8.4804 9.0204L8.296 4.50418C8.2735 3.95235 7.8045 3.51492 7.26405 3.62869C6.448 3.80048 5.67296 4.14133 4.99061 4.63338C4.03653 5.32138 3.30573 6.27465 2.88906 7.37465C2.47239 8.4746 2.38823 9.6728 2.64706 10.8202C2.90588 11.9677 3.49627 13.0138 4.34481 13.8284C5.19335 14.643 6.2626 15.1902 7.41965 15.4019C8.5767 15.6137 9.77045 15.4808 10.8526 15.0196C11.9346 14.5584 12.8573 13.7893 13.5058 12.808C13.9696 12.1061 14.2785 11.3178 14.4169 10.4954Z"
      />
    </svg>
  );
};

export default OutcomeIcon;
